// @flow
import type {Node} from 'react'
import React from 'react'
import {graphql, useFragment} from 'react-relay'

import SectionItem from 'components/SideBar/ui/SectionItem'
import type {
  YourProfileAndSettings_viewer$key as ViewerKey,
} from './__generated__/YourProfileAndSettings_viewer.graphql'

type Props = $ReadOnly<{
  viewer: ViewerKey,
}>

const viewerFragment = graphql`
  fragment YourProfileAndSettings_viewer on Person {
    resourcePath
  }
`

function YourProfileAndSettings({
  viewer: viewerKey,
}: Props): Node {
  const viewer = useFragment(viewerFragment, viewerKey)

  return (
    <SectionItem
      title={I18n.t('side_nav.your_profile_and_settings.title')}
      target="_blank"
      href={viewer.resourcePath}
    />
  )
}

export default YourProfileAndSettings
